import { render, staticRenderFns } from "./Target.vue?vue&type=template&id=6b4176c8&scoped=true&"
import script from "./Target.vue?vue&type=script&lang=js&"
export * from "./Target.vue?vue&type=script&lang=js&"
import style0 from "./Target.vue?vue&type=style&index=0&id=6b4176c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4176c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VBtn,VCard,VHover})
